// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1BQZe","colMaxWidth":"Table_colMaxWidth__2ekfy"};